import React from 'react'
import { PlayerSafetyScreen } from '../../../components/settings/PlayerSafetyScreen'

export default function BlockedUsersRoute() {
  return <PlayerSafetyScreen />
}
